import request from '@/utils/request'

export function getList (entity, filters = {}, pagination = {}) {
  //issue 242 services
  if (entity === 'log')
  {
    filters["response"] = "%{%"
  }
  //issue 242 services

  //issue 316 - modifica date da-a
  for(var t in filters)
  {
    if (t.indexOf("_$$$_from") > -1)
    {
      var oldval1 = filters[t]
      filters[t] = {}
      filters[t][t.split('_$$$_from')[0]] = '>='+ oldval1
    }
    if (t.indexOf("_$$$_to") > -1)
    {
      var oldval2 = filters[t]
      filters[t] = {}
      filters[t][t.split('_$$$_to')[0]] = '<='+ oldval2
    }
  }
  //issue 316 - modifica date da-a

  return request({
    url: '/' + entity,
    method: 'get',
    headers: {
      'x-filters': JSON.stringify(filters),
      'x-pagination': JSON.stringify(pagination)
    }
  })
}

export function getCount (entity, filters = {}) {
  //issue 242 services
  if (entity === 'log')
  {
    filters["response"] = "%{%"
  }
  //issue 242 services

  //issue 316 - modifica date da-a
  for(var t in filters)
  {
    if (t.indexOf("_$$$_from") > -1)
    {
      var oldval1 = filters[t]
      filters[t] = {}
      filters[t][t.split('_$$$_from')[0]] = '>='+ oldval1
    }
    if (t.indexOf("_$$$_to") > -1)
    {
      var oldval2 = filters[t]
      filters[t] = {}
      filters[t][t.split('_$$$_to')[0]] = '<='+ oldval2
    }
  }
  //issue 316 - modifica date da-a
    
  return request({
    url: '/' + entity,
    method: 'get',
    headers: {
      'x-filters': JSON.stringify(filters),
      'x-pagination': JSON.stringify({ rowsPerPage: 1 })
    }
  }).then(ret => ret.tot)
}



export function getDetail (entity, item) {
  return request({
    url: '/' + entity + (item && item.id ? '/' + item.id  : ''),
    method: 'get'
  })
}

export function get (url) {
  return request({
    url,
    method: 'get',
  })
}

export function put (entity, id, data) {
  const method = 'put'
  const url = '/' + entity + '/' + id
  return request({
    url,
    method,
    data
  })
}

export function upsert (entity, data, id,forcePut=null) {
  let method = 'post'
  let url = '/' + entity
  if (id) {
    method = 'put'
    url = '/' + entity + '/' + id
  }
  if(forcePut){
    method = 'put'
    url = '/' + entity 
  }
  return request({
    url,
    method,
    data
  })
}

export function remove (entity, item) {
  return request({
    url: '/' + entity + '/' + item.id,
    method: 'delete'
  })
}
